class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      // updateSliderCart();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


class DiscountCoupon extends HTMLElement {
  constructor() {
    super();

    this.cart = this.closest("cart-drawer");
  }
  
  connectedCallback() {
    this.bindEvents();
    this.checkAlways();
  }

  checkAlways(event) {
    const applyBtn = this.closest("cart-drawer")?.querySelector('.copy-discount');
    const totalPrice = this.querySelector(".cart-drawer__footer").getAttribute("total-amount") || "0";
    const totalCartValue = parseFloat(totalPrice) / 100;
    if (applyBtn) {
      const minCartValue = parseInt(applyBtn.getAttribute("data-min-cart"), 10);
      const state = this.querySelector(".cart-drawer__footer").getAttribute("state") || "false";
      if (state === "true") {
        if (totalCartValue < minCartValue) {
          // this.removeDiscount(this)
        }
      }
    }
  }
  
  bindEvents() {
    this.openDiscountButton = this.querySelector(".coupon-wrapper.applyButton");
    if(this.openDiscountButton) this.openDiscountButton.addEventListener('click', this.openDiscount.bind(this));
    this.closeDiscountButton = this.closest("cart-drawer")?.querySelector(".close-discount-modal");
    if(this.closeDiscountButton) this.closeDiscountButton.addEventListener('click', this.closeDiscount.bind(this));
    this.modalWrapper = this.closest("cart-drawer")?.querySelector(".discount-modal-wrapper");
    if (this.modalWrapper) this.modalWrapper.addEventListener('click', this.opener.bind(this));
    this.formButton = this.closest("cart-drawer")?.querySelector(".copy-discount");
    if (this.formButton) this.formButton.addEventListener('click', this.copyCode.bind(this));
    this.formButton2 = this.closest("cart-drawer")?.querySelector(".discount-form-button");
    if (this.formButton2) this.formButton2.addEventListener('click', this.applyDiscount.bind(this));
    this.removeButton = this.closest("cart-drawer")?.querySelector(".coupon_wrapper_remove");
    this.removeButton2 = this.closest("cart-drawer")?.querySelector(".removeCouponBtn");
    if (this.removeButton) this.removeButton.addEventListener('click', this.removeDiscount.bind(this));
    if (this.removeButton2) this.removeButton2.addEventListener('click', this.removeDiscount.bind(this));
    this.removeDiscountCode = this.closest("cart-drawer")?.querySelector("#removeCouponBtn");
    if (this.removeDiscountCode) this.removeDiscountCode.addEventListener('click', this.removeCode.bind(this));
    this.discountCodes = this.closest("cart-drawer")?.querySelector(".discount-links");
    // if (this.discountCodes) this.discountCodes.addEventListener('click', this.removeAll.bind(this));
  }
  
  openDiscount(event) {
    const overLay = event.target.closest("cart-drawer")?.querySelector(".discount-modal-wrapper");
    const discountModel = event.target.closest("cart-drawer")?.querySelector(".discount-modal");
    if (overLay) { overLay.classList.add("active");  overLay.style.display = "block"; }
    if (discountModel) { discountModel.style.display = "block"; }
  }

  closeDiscount(event) {
    const overLay = event.target.closest("cart-drawer")?.querySelector(".discount-modal-wrapper");
    const discountModel = event.target.closest("cart-drawer")?.querySelector(".discount-modal");
    if (overLay) { overLay.classList.remove("active");  overLay.style.display = "none"; }
    if (discountModel) { discountModel.style.display = "none"; }
  }

  opener(event) {
    if (event.target.classList.contains("active")) {
      event.target.classList.remove("active");
      event.target.style.display = "none";
    }
  }

  applyDiscount(event) {
    const applyBtn = event.target.closest("cart-drawer")?.querySelector('.copy-discount');
    const totatCart = event.target.closest("cart-drawer")?.querySelector('.subtotal');
    const totalPrice = this.querySelector(".cart-drawer__footer").getAttribute("total-amount") || "0";
    const totalCartValue = parseFloat(totalPrice) / 100;
    const minCartValue = parseInt(applyBtn.getAttribute("data-min-cart"), 10);
    const inputField = event.target.closest(".discount-overlay").querySelector('.discount-form-input');
    const inputValue = inputField?.value.trim().toUpperCase();
    const validCouponCodes = Array.from(event.target.closest("cart-drawer")?.querySelectorAll('.coupon-code-list .discount-title')).map(title => title.textContent.trim().toUpperCase());
    const successMessage = event.target.closest("cart-drawer")?.querySelector(".successfully_msg");
    const errorMessage = event.target.closest("cart-drawer")?.querySelector(".error-msg");
    if (!inputValue) {
      if (successMessage) successMessage.style.display = "none";
      if (errorMessage) {
        errorMessage.style.display = "block";
        errorMessage.innerText = "Please enter a coupon code.";
      }
    }
    else if (totalCartValue < minCartValue) {
      if (successMessage) successMessage.style.display = "none";
      if (errorMessage) {
        errorMessage.style.display = "block";
        errorMessage.innerText = `Minimum purchase of ₹${minCartValue} required to use this coupon.`;
      }
    }
    else if (totalCartValue < minCartValue) {
      if (successMessage) successMessage.style.display = "none";
      if (errorMessage) {
        errorMessage.style.display = "block";
        errorMessage.innerText = `Invalid Coupon code`;
      }
    }
    else {
      if (successMessage) successMessage.style.display = "block";
      if (errorMessage) {
        errorMessage.style.display = "none";
        errorMessage.innerText = ``;
      }
      console.log("successMessage",successMessage);
      if (inputValue === 'EXTRA10') {
        this.applyDiscountUsingFetch(event);
      } else {
        this.applyDiscountUsingFetch(event);
      }
    }
  }

  async applyDiscountUsingFetch(event) {
    const code = event.target.closest("cart-drawer")?.querySelector(".discount-form-input").value;
    fetch(`/discount/${code === "" ? "no" : code}?sections=cart-drawer,cart-icon-bubble`).then((response) => {
      return response.json();
    }).then((response) => {
      const data = {
        id: "",
        sections: response
      }
      this.cart.renderContents(data);
    });
  }

  removeDiscount(event) {
    fetch(`/discount/no?sections=cart-drawer,cart-icon-bubble`).then((response) => {
      return response.json();
    }).then((response) => {
      const data = {
        id: "",
        sections: response
      }
      this.cart.renderContents(data);
    })
  }

  toggleCouponSection(event) {
    const inputApplyButton = event.target.closest("cart-drawer")?.querySelector('.discount-form-button');
    const applyBtn = event.target.closest("cart-drawer")?.querySelector('.copy-discount');
    const couponWrapper = event.target.closest("cart-drawer")?.querySelector('.coupon-wrapper.applyButton');
    const couponWrapperRemove = event.target.closest("cart-drawer")?.querySelector('.coupon_wrapper_remove');
    const modal = event.target.closest("cart-drawer")?.querySelector('.discount-modal');
    const isCouponApplied = applyBtn && applyBtn.textContent === (applyBtn.getAttribute("data-coupon-message") || "");
    if (isCouponApplied) {
      if (couponWrapperRemove) {
        couponWrapperRemove.style.display = 'none';
      }
      if (modal) {
        modal.style.display = 'none';
      }
    } else {
      if (couponWrapperRemove) {
        couponWrapperRemove.style.display = 'block';
      }
      if (modal) {
        modal.style.display = 'none';
      }
    }
  }

  removeCode(event) {
    const wrapper = event.target.closest("cart-drawer")?.querySelector('.coupon-wrapper.applyButton');
    if (wrapper) wrapper.style.display = "flex";
    const message = event.target.closest("cart-drawer")?.querySelector('.successfully_msg')
    if (message) message.style.display = "none";
    const errorMessage = event.target.closest("cart-drawer")?.querySelector('.error-msg');
    if (errorMessage) errorMessage.style.display = "none";
  }

  removeAll(event) {
    const wrapper = event.target.closest("cart-drawer")?.querySelector('.coupon-wrapper.applyButton');
    if (wrapper) wrapper.style.display = "none";
    const removeWrapper = event.target.closest("cart-drawer")?.querySelector(".coupon_wrapper_remove");
    if (removeWrapper) removeWrapper.style.display =  "block";
    const appliedCoupon = event.target.closest("cart-drawer")?.querySelector(".applied_Coupon");
    if (appliedCoupon) removeWrapper.style.display =  "block";
    const modalDiscount = event.target.closest("cart-drawer")?.querySelector(".discount-modal");
    if (modalDiscount) removeWrapper.style.display =  "block";
    setTimeout(() => {
      if (modalDiscount) modalDiscount.style.display =  "none";
      const modalDiscountWrapper = event.target.closest("cart-drawer")?.querySelector(".discount-modal-wrapper");
      if (modalDiscountWrapper) {
        modalDiscountWrapper.classList.remove("active");
        modalDiscountWrapper.style.display = "none";
      }
    }, 1000);
  }

  copyCode(event) {
    const code = event.target.getAttribute("data-coupon-code");
    const formInput = event.target.closest("cart-drawer")?.querySelector(".discount-form-input");
    const applyButton = event.target.closest("cart-drawer")?.querySelector(".discount-form-button");
    if (formInput) {
      formInput.value = code;
      formInput.setAttribute("value", code);
      if (applyButton) {
        applyButton.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        }))
      }
    }
  }
}

customElements.define('discount-coupon', DiscountCoupon);


